import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { useHistory, useLocation } from "react-router-dom";

interface StaticsProps {
    current: string;
    onChange: (current: string) => void;
    allCount: string;
    joinCount: string;
    noJoinCount: string;
}

export default function Statics({
    current,
    onChange,
    allCount,
    joinCount,
    noJoinCount
}: StaticsProps) {
    const history = useHistory();
    const { pathname } = useLocation();

    function handleClick(params: string) {
        onChange(params);
        history.replace(`${pathname}?status=${params}`);
    }

    return (
        <div className={style.root}>
            <div
                className={classNames(style.statics, {
                    [style.active]: current === "all"
                })}
                onClick={() => handleClick("all")}>
                <em>{allCount || 0}</em>课程人数
            </div>
            <div
                className={classNames(style.statics, {
                    [style.active]: current === "joinCount"
                })}
                onClick={() => handleClick("joinCount")}>
                <em>{joinCount || 0}</em>已参与
            </div>
            <div
                className={classNames(style.statics, {
                    [style.active]: current === "noJoinCount"
                })}
                onClick={() => handleClick("noJoinCount")}>
                <em>{noJoinCount || 0}</em>未参与
            </div>
        </div>
    );
}
